// Unpublished Work © 2020-2022 Deere & Company

import {createTcombStoreWithDevTools} from '@deere/cap-it-ui.redux-store-creator';
import {getCombinedReducer} from '../reducers';
import {State} from '../state/state';
import {persistStore} from 'redux-persist';

export function createStore() {
    const reducer = getCombinedReducer();

    return createTcombStoreWithDevTools(reducer, State, [], {
        strict: false
    });
}

export const store = createStore();

export const persistor = persistStore(store);
